/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
    FormControl,
    InputLabel,
    Input,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    Grid,
    Typography,
} from '@material-ui/core';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

class TableFiltersMultiSelect extends Component {
    constructor(props) {
        super(props);
        const { filter, activeFilters } = this.props;

        this.state = { value: activeFilters[filter.fieldName] || [] };
    }

    handleChange = (event) => {
        const { onChange, filter } = this.props;

        this.setState({ value: event.target.value }, () =>
            onChange('multiselect', filter.fieldName, this.state.value)
        );
    };

    render() {
        const { filter } = this.props;
        return (
            <Grid>
                <FormControl style={{ width: '100%' }}>
                    <InputLabel htmlFor={filter.fieldName}>{filter.label}</InputLabel>
                    <Select
                        multiple
                        value={this.state.value}
                        onChange={this.handleChange}
                        input={<Input id={filter.fieldName} />}
                        renderValue={(selected) => selected.join(', ')}
                        MenuProps={MenuProps}
                    >
                        {filter.value.map((name) => (
                            <MenuItem id="yeself-menu-item" key={name} value={name}>
                                <Checkbox checked={this.state.value.indexOf(name) > -1} />
                                <ListItemText primary={name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        );
    }
}

export default TableFiltersMultiSelect;
